import * as yup from 'yup'

import { STATE_OPTIONS } from '@fourthwall/utils/dist/inputs'
import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  address1: Yup.string().max(50).required(),
  address2: Yup.string(),
  city: Yup.string().required(),
  country: Yup.string().required(),
  state: Yup.string().when('country', {
    is: (country: string) => !!STATE_OPTIONS[country],
    then: yup.string().required(),
  }),
  zip: Yup.string().required(),
})
